import toastr from 'toastr';
import 'toastr/build/toastr.css';

global.toastr = toastr;
